import { render } from "./VuexDateRangeSearchItem.vue?vue&type=template&id=0c05587c"
import script from "./VuexDateRangeSearchItem.vue?vue&type=script&lang=js"
export * from "./VuexDateRangeSearchItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__